import React from "react";
import ActionButton from "../partials/ActionButton";
import StagesManager from "../StagesManager";
import FormViewer from "../FormViewer";
import ViewSwitcher from "../ViewSwitcher";
import ViewsMenu from "../header/ViewsMenu";
import { chooseFontColor, imageAddress, textVariableReplacer, translate } from "../../utils/useful";
import ButtonAnimated from "../buttons/ButtonAnimated";
import HttpServices from "../../utils/Http.services";
import RecordViewerModal from "../../modals/RecordViewerModal";
import { saveAs } from 'file-saver';
import ViewSwitcherWidget from "./ViewSwitcherWidget";
import importedIcons from "../inputs/icons";

class TasksWidget extends React.Component {
    state = {

        limit: 12,
        skip: 0,
        currentView: "table",
        // pje: [
        //     { name: '1Attend a business meeting ...', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '6:30 am', img: "/images/p1.png", img2: "/images/p3.png" },
        //     { name: '1Reading Book', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '10:30 pm', img: "/images/p2.png", img2: "/images/p1.png" },
        //     { name: '1Reading Book', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '5:00 pm', img: "/images/p4.png", img2: "/images/p5.png" },
        //     { name: 'Attend a business meeting ...', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '1:30 am', img: "/images/p7.png", img2: "/images/p6.png" },
        //     { name: 'Reading Book', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '10:30 pm', img: "/images/p1.png", img2: "" },
        //     { name: 'Attend a business meeting ...', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '10:30 am', img: "/images/p1.png", img2: "/images/p8.png" },

        // ],
        category: [
            { bg: "bg-red-300", name: "All", title: "Attend a business meeting ...", des: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", title1: "Do somthing", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },
            { bg: "bg-red-300", name: "Pending", title: "Attend a business meeting ...", des: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", title1: "Exercise", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },
            { bg: "#99FFFF", name: "Open", title: "Reading Book", des: "meeting Attend a business meeting", title1: "Painting", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },
            { bg: "#DF73FF", name: "Closed", title: "Attend a business meeting ...", des: "choose the best option and create a pleasant shopping experience. .", title1: "Do somthing", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },

        ],
        actions: {
            // done: { key: "done", label: '{{lang}}Mark as done', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: this.openEditModal },
            edit: { key: "edit", label: '{{lang}}View / Edit', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openEditModal", icon: importedIcons.edit },
            changeStage: { key: "changeStage", label: '{{lang}}Change Stage', sub: true, color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "changeRecordStageModal", icon: importedIcons.changeStage },
            doneTask: { key: "doneTask", label: '{{lang}}DoneTask', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "doneTask", icon: importedIcons.changeStage },
            nextStage: { key: "nextStage", label: '{{lang}}Next Stage', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "nextRecordStage", icon: importedIcons.changeStage },

        },
        headers: [
            // { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}Title', inplaceEditable: true, placeholder: '{{lang}}desk.insert', required: false, disabled: true }, showMain: true },
            // { key: 'dueDate', type: 'DateInput', col: '6', information: { label: '{{lang}}Assignee', inplaceEditable: true, placeholder: '{{lang}}desk.Date', required: true }, showMain: true },
            // { key: 'priority', type: 'StatusSelectInput', inPlaceEdit: true, information: { label: '{{lang}}Time', inplaceEditable: true, placeholder: '{{lang}}desk.priority', items: [{ label: '{{lang}}desk.High', key: 'high', color: '#CA5C72', bgColor: '#FEE9EE' }, { label: '{{lang}}desk.Medium', key: 'medium', color: '#CAA55C', bgColor: '#FEF2E9' }, { label: '{{lang}}desk.Low', key: 'low', color: '#00c875', bgColor: '#00c87520' }], required: false } },
            // { key: 'assignees', type: 'GlobalUserMultiInput', information: { label: '{{lang}}desk.Assignees', inplaceEditable: true, address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}desk.select', required: false, } },
            // { key: 'source', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}desk.Source', inplaceEditable: true, required: true, type: 'local', default: '0', items: [{ title: "{{lang}}desk.Cash", value: 'C', color: '#789' }, { title: "{{lang}}desk.Credit Card", value: 'CC', color: '#789' },] }, showMain: true, inExport: true },
            // { key: 'tags', type: 'MultiSelectInput', fullCol: true, information: { label: '{{lang}}desk.Tags', inplaceEditable: true, required: true, type: 'local', default: '0', items: [{ title: "{{lang}}desk.Cash", value: 'C', color: '#789' }, { title: "{{lang}}desk.Credit Card", value: 'CC', color: '#789' },] }, showMain: true, inExport: true },

        ],


    }


    componentDidMount() {

        this.setState({ currentIndex: 0, currentItem: this.state.category[0] })
        this.init()
    }

    doneTask = (info, extra) => {
        let body = { _id: info._id }
        HttpServices.request('doneTask', body, (fetchResult, fetchError) => {
            if (fetchError) { return }
        })
    }

    init() {

        let data = { ...this.props.data }
        this.setState({ information: data })
        let body = { collection: data.collection }

        this.setState({ isLoading: true })
        // console.log('fffraem', body)

        HttpServices.request("getFrame", body, (fetchResult, fetchError, status) => {
            // SocketServices.addTopic(this.state.topicId, this.props.data.thing, 'things', null, this.updateData)

            // console.log(fetchResult)
            this.setState({ isLoading: false })

            if (fetchError) { return }

            let frame = fetchResult?.info

            frame.key = frame._id
            frame.section = 'collections'
            frame.pageType = 'collection'
            frame.fetchUrl = 'getMyTasks'
            frame.addUrl = 'changeTaskStage'
            frame.editUrl = 'changeTaskStage'
            frame.removeUrl = ''
            frame.postBody = { hub: frame?.applet?.hub, applet: frame?.applet?._id }
            frame.filter = { hub: frame?.applet?.hub, applet: frame?.applet?._id }
            frame.fields.forEach(field => {
                // if (!field.key.includes("values.")) {

                //     field.key = "values." + field.key
                // }
            });
            this.setState({ frame: frame }, () => {


                let body = frame.filter ? { ...frame.filter } : {}
                // let page = frame

                body.limit = this.state.limit
                body.skip = this.state.skip



                // body.page = page.key
                for (const [key, value] of Object.entries(body)) {
                    if (/\{\{(.*?)\}\}/.test(value)) {
                        if (this.props.variables) {
                            body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                        }
                    }
                }
                body.frame = frame?._id
                body.project = this.props.data.project
                body.options = this.props.data.options
                body.allProjects = this.props.data.allProjects
                // body.filter = filter

                // console.log(body)
                // console.log(frame.fetchUrl)
                this.setState({ isLoadingData: true })
                HttpServices.request(frame.fetchUrl, body, (tasksResult, fetchError) => {
                    this.setState({ isLoadingData: false })
                    if (fetchError) {
                        this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                        return
                    }
                    this.setState({ showTable: false }, () => {
                        this.setState({ data: tasksResult.info, showTable: true }, () => {
                        })
                    })
                })


            })

        })

    }


    functionsHandler = (type, name, data, extra, info) => {
        // console.log("functionsHandler")
        // console.log(type, name, data, extra)

        // if (!this.props.userView) {

        console.log("functionsHandler", name)

        if (this[name]) {
            this[name](data, extra, info)
        } else {
            if (this.props.functionsHandler) {
                this.props.functionsHandler(type, name, data, extra, info)
            }
        }
        // }
        // else {
        //     console.log("functionsHandlerptop", this.props)
        //     console.log("functionsHandlerstate", this.state)
        // }
    }



    downloadFile = (fullData, extra, info) => {

        // console.log("params", this.props.params)

        // console.log('downloadFile', fullData, extra, info)
        // let file = 'test.png'



        let data = textVariableReplacer(fullData, info?.source, extra?.headers, 'View Record')

        if (Array.isArray(this.props.params)) {
            for (let i = 0; i < this.props.params.length; i++) {
                const param = this.props.params[i];
                data = this.textVariableReplacer(param?.info, data, param.fields, param.label)

            }
        }


        // console.log(data)
        // return


        saveAs(imageAddress(data))

    }




    openWindow = (prop, extra, info) => {
        // console.log('openWindow', prop, extra, info)
        // console.log('this.props.baseUrl', this.props.baseUrl)
        let newLink = this.props.baseUrl.splice(2)
        // return
        newLink.push(info.page)
        newLink.push(prop._id)
        // return
        // console.log('widgettttap', this.props.applet)
        // console.log('newLink', newLink)

        // return
        this.props.changeWindowLink(newLink)


    }

    openEditModal = (prop, extra) => {
        // console.log('this.props.page', this.props.page)

        if (!this.props.userView) {

            let baseUrl = this.props.baseUrl
            let windowData = this.props.windowData
            let data = { ...this.props.data }


            // console.log("baseUrl, ", baseUrl)
            // console.log("windowData, ", windowData)
            // console.log("data, ", data)
            // console.log(this.props.section)

            
            this.setState({ currentItem: prop, currentIndex: extra?.index },()=>{
                this.RecordViewerModal.showModal()

            })

        }
        return

        let newLink = this.props.baseUrl?.splice(2)
        if (!newLink) {
            newLink = []
        }
        newLink.push(this.props.page?.key)
        newLink.push(prop._id)
        if (this.props.page?.customEdit) {
            let variables = this.props.variables ?? {}
            variables.currentItem = prop
            this.setState({ variables })
            this.props.changeWindowLink(newLink)
        } else {
            this.setState({ currentItem: null }, () => {
                let variables = this.props.variables ?? {}
                variables.currentItem = prop
                this.setState({ variables })
                if (this.state.relevants?.length > 0) {
                    this.setState({ relevantEdit: true })
                }
                else {
                    this.setState({ edit: true })
                }
                this.setState({ currentItem: prop, currentIndex: extra?.index })
                this.props.changeWindowLink(newLink)
            })
        }
    }





    render() {

        let colors = {
            primaryColor: '#5856d6',
            secondaryColor: '#7c7aff',
            textColor: '#fff'
        }

        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false

        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`

        let view = this.props.data?.view ?? {}
        view.type = this.props.data?.type ?? 'table'

        let headersItemModal = null
        let variables = { ...this.props.variables }
        // variables.frameId = this.state.currentRelevantTab ?? this.props.page?._id
        // variables.currentItem = this.state.relevantCurrentItem ?? this.state.currentItem


        return (
            <div className=" w-100 h-100 " >
                {/* <ViewSwitcherWidget viewType={'table'} data={this.props.data} variables={this.props.variables} functionsHandler={this.props.functionsHandler} params={this.props.params} baseUrl={this.props.baseUrl} changeWindowLink={this.props.changeWindowLink} windowData={this.props.windowData} page={this.props.page} width={this.props.width} formPages={this.props.formPages} isMobile={this.props.isMobile} colors={colors} /> */}
                <ViewSwitcher
                    applet={this.state.frame?.applet}
                    data={this.state.data}
                    permissions={this.props.permissions}
                    headers={this.state.frame?.fields}
                    page={this.state.frame}
                    params={this.props.params}
                    actions={this.state.actions}
                    width={this.props.width}
                    functionsHandler={this.functionsHandler}
                    submitForm={this.submitForm}
                    changeValue={this.changeValue}
                    view={view}
                    isLoadingData={this.state.isLoadingData}
                    type={this.props.viewType ?? this.props.view?.type}
                />
            </div >
        )
    }
}



export default TasksWidget;